import cx from 'classnames'
import get from 'lodash/get'
import { useState } from 'react'
import useUpdateShared from '../hooks/useUpdateShared'
import CollapsedNotification from './CollapsedNotification'
import Notification from './Notification'

export default function Occupation({ checkoutSummary }) {
  return checkoutSummary?.cabinOverview?.map((product, index, array) => {
    const isUpgraded = get(product, 'items[0].upgraded', false)
    const isShared = get(product, 'items[0].isShared', false)
    const isShareable = get(product, 'room.isShared')
    const guestsQty = get(product, 'items[0].numberOfInstances', 0)
    const maxOccupancy = get(product, 'room.roomCategory.maxOccupancy', 0)
    const [isCollapsed, setIsCollapsed] = useState(false)

    const { updateShared, newOccupancy } = useUpdateShared()

    if(!isShared && guestsQty === maxOccupancy) {
      return null
    }
    if(!isShareable && isCollapsed) {
      return null
    }

    return (
      <div
        className={cx('notification clearfix', {
          'collapsed-block': isCollapsed,
        })}
        key={index}
      >
        {isCollapsed ? (
          <CollapsedNotification
            isUpgraded={isUpgraded}
            setIsCollapsed={setIsCollapsed}
            product={product}
            updateShared={updateShared}
          />
        ) : (
          <Notification
            product={product}
            isShared={isShared}
            isShareable={isShareable}
            isUpgraded={isUpgraded}
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            numberOfProducts={array.length}
            maxOccupancy={maxOccupancy}
            currency={checkoutSummary.currency}
            updateShared={updateShared}
            occupancy={newOccupancy}
          />
        )}
      </div>
    )
  })
}
